// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__9r9Q-","cell":"ColumnAccessor_cell__3kAnT","firstCellAccent":"ColumnAccessor_firstCellAccent__3dBMb"};